import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  buildUserSkinParameters,
  ParameterViewModel,
  SEVERITY_LEVELS,
  SKIN_PARAMETER_KEYS,
  SkinParametersInfo,
} from '../../../../helper/report-helper/report-helper';

@Component({
  selector: 'rebranded-skin-parameter',
  imports: [CommonModule],
  templateUrl: './rebranded-skin-parameter.component.html',
})
export class RebrandedSkinParameterComponent {
  readonly severityLevels = SEVERITY_LEVELS;
  readonly skinParameterKeys = SKIN_PARAMETER_KEYS;
  skinParametersInfo = input<SkinParametersInfo | null>();

  userSkinParameters = computed<ParameterViewModel[]>((): ParameterViewModel[] => {
    return buildUserSkinParameters(this.skinParametersInfo());
  });

  getBubbleLeftPosition(scorePercentage: number): number {
    return Math.max(2, Math.min(100, scorePercentage));
  }
}
